import React from "react";
import "../style.css";

export default function CookiesConsent({ setCookies, cookieName }) {
  return (
    <footer className="cookies-poilcy-footer">
      <p>This site uses cookies</p>
      <p>
        These cookies are used to collect information about how you interact
        with our website and allow us to remember you.
        <br /> We use this information in order to improve and customize your
        browsing experience and for analytics and metrics. <br /> For
        information about our cookies, see our{" "}
        <a
          className={"small text-avi-primary pointer"}
          href="/pages/privacy-page"
        >
          Privacy policy
        </a>
        Read about our Privacy policy{" "}
        <a
          href="/pages/cookies-page"
          className="text-decoration: underline; color: inherit;"
        >
          Cookie Policy
        </a>{" "}
      </p>
<div>
      <button class="fix-btn"
           onClick={() => setCookies(cookieName, true, 365)}
      > Accept</button>
      </div>
    </footer>
  );
}



// WEBPACK FOOTER //
// ./src/views/pages/cookies-page/cookies-consent.js